import React from 'react';
import { Button, Row } from 'saladsoft-primitive';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';

const NewButton = ({ children, onClick, isValid = true }: { children: React.ReactNode, onClick?: () => void, isValid?: boolean }) => {
  return (
    <ButtonContainer isValid={isValid} onClick={onClick}>
      <Row gap={10} margin="0 5px" marginRight="20px" whiteSpace="nowrap">
        <IconButton style={{ background: 'rgba(255, 255, 255, 0.2)', borderRadius: '36px', width: 24, height: 24 }}>
          <AddIcon style={{ color: '#fff', fontSize: 18 }} />
        </IconButton>
        <>{children}</>
      </Row>
    </ButtonContainer>
  );
};

const ButtonContainer = styled(Button) <{ isValid?: boolean }>`
  background: ${({ isValid }) => isValid ? 'var(--point-color)' : 'var(--Grayscale-20, #E0E0E0)'};
  cursor: ${({ isValid }) => isValid ? 'pointer' : 'not-allowed'};
`;
export default NewButton;
